import { render, staticRenderFns } from "./chartSales.vue?vue&type=template&id=309ae854"
import script from "./chartSales.vue?vue&type=script&lang=js"
export * from "./chartSales.vue?vue&type=script&lang=js"
import style0 from "./chartSales.vue?vue&type=style&index=0&id=309ae854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports